import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #000080; /* Azul escuro */
    --secondary-color: #1E90FF; /* Azul mais claro */
    --accent-color: #00BFFF; /* Azul brilhante */
    --text-color: #333333;
    --light-text: #FFFFFF;
    --background-color: #F5F5F5;
    --card-background: #FFFFFF;
    --gradient-blue: linear-gradient(135deg, #000080 0%, #1E90FF 100%);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Roboto', sans-serif;
    color: var(--text-color);
    background-color: var(--background-color);
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: color 0.3s ease;

    &:hover {
      color: var(--accent-color);
    }
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: var(--primary-color);
    color: var(--light-text);
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    font-weight: 500;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: var(--secondary-color);
    }
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .section {
    padding: 4rem 0;
  }

  .text-center {
    text-align: center;
  }

  .gradient-bg {
    background: var(--gradient-blue);
    color: var(--light-text);
  }
`;

export default GlobalStyles;